export default "__VITE_ASSET__XpH_TAQI__"